<template>
  <div class="invigilate" v-loading="loading">
    <div class="wrap flex">
      <h2>监考记录</h2>
      <!-- <div>
        时间：
        <el-date-picker
          v-model="date"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        --
        <el-date-picker
          v-model="date"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div> -->
    </div>

    <el-card>
      <div class="flex">
        <div class="title"><b class="line">|</b>严重违规</div>
        <span>
          提示：由于是系统监考，因此不排除“误判”的可能性，请监考人员对“标红”的考生进行酌情排查！
        </span>
      </div>
      <el-row :gutter="20">
        <el-col
          :span="8"
          v-for="item in arr"
          :key="item.id"
          v-show="
            item.noself >= 3 ||
              item.other >= 1 ||
              item.nocheck >= 5 ||
              item.close >= 1 ||
              item.many >= 3 ||
              item.leave >= 1
          "
        >
          <div class="box">
            <div class="name">
              <b>{{ item.name }}</b>
              <span class="department">{{ item.sys_class_name }}</span>
              <el-popover
                placement="bottom"
                width="200"
                trigger="click"
                :content="content"
                @hide="popover_hide(item.paper_id, item.index)"
              >
                <div
                  slot="reference"
                  style="float:right"
                  v-show="
                    item.noself >= 3 ||
                      item.other >= 1 ||
                      item.nocheck >= 5 ||
                      item.close >= 1 ||
                      item.many >= 3 ||
                      item.leave >= 1
                  "
                  v-if="item.alert_sign == 1"
                  @click="illegal(item)"
                >
                  <img
                    src="../../../assets/circle.png"
                    class="circleImg"
                    alt=""
                  />
                  <div class="circle">
                    <p>!</p>
                  </div>
                </div>
              </el-popover>
              <div class="exam_time ">
                <span>开考时间：{{ item.result.created_at }}</span
                ><br />
                <span v-if="item.result.status == 0">交卷时间：未交卷</span>
                <span v-else>交卷时间：{{ item.result.updated_at }}</span>
              </div>
            </div>
            <el-row>
              <el-col :span="8">
                <div
                  @click="toInvigilate(item.user_id, item.paper_id)"
                  :class="[
                    item.noself >= 3 ? 'err' : '',
                    item.noself < 3 && item.noself != 0 ? 'warning' : '',
                    item.noself == 0 ? 'success' : '',
                  ]"
                >
                  {{ item.noself }} <span>次</span>
                </div>
                <div>考试非本人</div>
              </el-col>
              <el-col :span="8">
                <div
                  @click="toInvigilate(item.user_id, item.paper_id)"
                  :class="item.other >= 1 ? 'err' : 'success'"
                >
                  {{ item.other }} <span>次</span>
                </div>
                <div>使用其他窗口</div>
              </el-col>
              <el-col :span="8">
                <div
                  @click="toInvigilate(item.user_id, item.paper_id)"
                  :class="[
                    item.nocheck >= 5 ? 'err' : '',
                    item.nocheck < 5 && item.nocheck != 0 ? 'warning' : '',
                    item.nocheck == 0 ? 'success' : '',
                  ]"
                >
                  {{ item.nocheck }} <span>次</span>
                </div>
                <div>检测不到考生</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div
                  @click="toInvigilate(item.user_id, item.paper_id)"
                  :class="item.close >= 1 ? 'err' : 'success'"
                >
                  {{ item.close }} <span>次</span>
                </div>
                <div>关闭摄像头</div>
              </el-col>
              <el-col :span="8">
                <div
                  @click="toInvigilate(item.user_id, item.paper_id)"
                  :class="[
                    item.many >= 3 ? 'err' : '',
                    item.many < 3 && item.many != 0 ? 'warning' : '',
                    item.many == 0 ? 'success' : '',
                  ]"
                >
                  {{ item.many }} <span>次</span>
                </div>
                <div>出现多人同框</div>
              </el-col>
              <el-col :span="8">
                <!-- <div
                  @click="toInvigilate(item.user_id, item.paper_id)"
                  :class="item.leave >= 1 ? 'err' : 'success'"
                >
                  {{ item.leave }} <span>次</span>
                </div>
                <div>离开考场</div> -->
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card>
      <div class="flex">
        <div class="title"><b class="line">|</b>正常监考</div>
      </div>
      <el-row :gutter="20">
        <el-col
          :span="8"
          v-for="(item, index) in arr"
          :key="item.id"
          v-show="
            item.noself < 3 &&
              item.other < 1 &&
              item.nocheck < 5 &&
              item.close < 1 &&
              item.many < 3 &&
              item.leave < 1
          "
        >
          <div class="box">
            <div class="name">
              <b @click="toInvigilate(item.user_id, item.paper_id)">{{
                item.name
              }}</b>
              <span class="department">{{ item.sys_class_name }}</span>

              <el-popover
                placement="bottom"
                width="200"
                trigger="click"
                :content="content"
                @hide="popover_hide(item.paper_id, index)"
              >
                <i
                  v-show="
                    item.noself >= 3 ||
                      item.other >= 1 ||
                      item.nocheck >= 5 ||
                      item.close >= 1 ||
                      item.many >= 3 ||
                      item.leave >= 1
                  "
                  v-if="item.alert_sign == 1"
                  slot="reference"
                  class="el-icon-warning"
                  @click="illegal(item)"
                ></i>
              </el-popover>
              <div class="exam_time ">
                <span>开考时间：{{ item.result.created_at }}</span
                ><br /><span v-if="item.result.status == 0"
                  >交卷时间：未交卷</span
                >
                <span v-else>交卷时间：{{ item.result.updated_at }}</span>
              </div>
            </div>
            <el-row>
              <el-col :span="8">
                <div
                  :class="[
                    item.noself >= 3 ? 'err' : '',
                    item.noself < 3 && item.noself != 0 ? 'warning' : '',
                    item.noself == 0 ? 'success' : '',
                  ]"
                >
                  {{ item.noself }} <span>次</span>
                </div>
                <div>考试非本人</div>
              </el-col>
              <el-col :span="8">
                <div :class="item.other >= 1 ? 'err' : 'success'">
                  {{ item.other }} <span>次</span>
                </div>
                <div>使用其他窗口</div>
              </el-col>
              <el-col :span="8">
                <div
                  :class="[
                    item.nocheck >= 5 ? 'err' : '',
                    item.nocheck < 5 && item.nocheck != 0 ? 'warning' : '',
                    item.nocheck == 0 ? 'success' : '',
                  ]"
                >
                  {{ item.nocheck }} <span>次</span>
                </div>
                <div>检测不到考生</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div :class="item.close >= 1 ? 'err' : 'success'">
                  {{ item.close }} <span>次</span>
                </div>
                <div>关闭摄像头</div>
              </el-col>
              <el-col :span="8">
                <div
                  :class="[
                    item.many >= 3 ? 'err' : '',
                    item.many < 3 && item.many != 0 ? 'warning' : '',
                    item.many == 0 ? 'success' : '',
                  ]"
                >
                  {{ item.many }} <span>次</span>
                </div>
                <div>出现多人同框</div>
              </el-col>
              <el-col :span="8">
                <!-- <div :class="item.leave >= 1 ? 'err' : 'success'">
                  {{ item.leave }} <span>次</span>
                </div>
                <div>离开考场</div> -->
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { loadFaceLandmarkModel } from "face-api.js";
export default {
  name: "invigilateChart",
  data() {
    return {
      date: "",
      loading: false,
      num: 1,
      paper_id: "",
      arr: [],
      content: "",
      timer: null,
    };
  },
  created() {
    let _this = this;
    _this.paper_id = this.$route.query.id;
  },
  mounted() {
    this.init();
    this.timer = setInterval(() => {
      setTimeout(this.init, 0);
    }, 1000 * 60);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    init() {
      let _this = this;
      _this.$http
        .post(process.env.VUE_APP_API_URL + "admin/invigilate", {
          paper_id: _this.paper_id,
        })
        .then(function(data) {
          if (data.data.code == 200) {
            _this.arr = data.data.data;
            let classData = data.data.class;
            localStorage.setItem("classData", JSON.stringify(data.data.class));
            _this.arr.forEach((ele, index) => {
              ele.index = index;
              if (ele.result.class_id) {
                ele.sys_class_name = classData.find(
                  (item) => item.sys_class_id == ele.result.class_id
                ).sys_class_name;
              }
            });
            _this.arr.forEach((ele) => {
              if (ele.result.created_at) {
                ele.sort_created_at = ele.result.created_at;
                _this.arr.sort(function(a, b) {
                  if (a.alert_sign == b.alert_sign) {
                    return (
                      Date.parse(b.sort_created_at) -
                      Date.parse(a.sort_created_at)
                    );
                  } else {
                    return b.alert_sign - a.alert_sign;
                  }
                });
              }
            });
          } else {
            _this.$message.error(data.data.msg);
          }
        })
        .catch(function(error) {
          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return;
        });
    },
    toInvigilate(user_id, paper_id) {
      this.$router.push({
        name: "invigilate",
        query: { user_id: user_id, paper_id: paper_id },
      });
    },
    illegal(item) {
      this.content = "该考生有以下严重违规行为：";
      if (item.noself >= 3) {
        this.content = `${this.content}
        ● 检测到非本人；`;
      }
      if (item.other >= 1) {
        this.content = `${this.content}
         ● 使用其他窗口；`;
      }
      if (item.nocheck >= 5) {
        this.content = `${this.content}
        ● 检测不到考生；`;
      }
      if (item.close >= 1) {
        this.content = `${this.content}
        ● 关闭摄像头；`;
      }
      if (item.many >= 3) {
        this.content = `${this.content}
        ● 出现多人同框；`;
      }
      // if (item.leave >= 1) {
      //   this.content = `${this.content}
      //    ● 离开考场；`
      // }
    },
    popover_hide(paper_id, index) {
      let _this = this;
      _this.$http
        .post(process.env.VUE_APP_API_URL + "admin/invigilate/alertSign", {
          paper_id: paper_id,
          index: index,
        })
        .then(function(data) {
          if (data.data.code == 200) {
            _this.init();
          } else {
            _this.$message.error(data.data.msg);
          }
        })
        .catch(function(error) {
          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  height: 50px;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title {
  justify-content: flex-start;
  font-size: 20px;
}
.line {
  background-color: #303133;
  margin-right: 20px;
}
.box {
  background: #f8f9fa;
  border-radius: 8px;
  height: 320px;
}

.el-row {
  padding: 25px 20px 0 20px;
}

.exam_time span {
  font-size: 13px !important;
  color: #9b9b9b;
}
.name {
  line-height: 25px;
  border-bottom: 1px solid #ccc;
  margin: 0 20px 0 20px;
  text-align: left;
  padding-top: 10px;
}
.name b {
  font-size: 26px;
  color: #333333;
}
.department {
  font-size: 17px !important;
  padding-left: 15px;
  color: #727272;
}
.success {
  font-size: 34px !important;
  font-family: Fantasy;
  margin-bottom: 5px;
  color: #00b388 !important;
  cursor: pointer;
}
.warning {
  font-size: 34px !important;
  font-family: Fantasy;
  margin-bottom: 5px;
  color: #ffac04 !important;
  cursor: pointer;
}
.err {
  font-size: 34px !important;
  font-family: Fantasy;
  margin-bottom: 5px;
  color: #ff4444 !important;
  cursor: pointer;
}

.el-col div {
  font-size: 18px;
  color: #727272;
}

.el-col span {
  font-size: 14px;
}
.el-col {
  text-align: center;
  margin-bottom: 20px;
}
.circle {
  width: 35px;
  height: 35px;
  background-color: #ff4444;
  border-radius: 50%;
  position: absolute;
  margin-left: 16px;
  // left: 54px;
  top: 50px;
  cursor: pointer;
}
.circle p {
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  line-height: 35px;
  height: 35px;
  position: absolute;
  left: 15px;
  top: -19px;
}
.circleImg {
  width: 65px;
  position: relative;
  animation: flash 2s ease infinite;
  animation-direction: alternate;
}
@keyframes flash {
  0% {
    opacity: 0.1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
</style>
<style>
.el-popper {
  white-space: pre-line;
  border: 1px solid #ccc;
}
</style>
